module.exports = __webpack_public_path__ + "static/media/TH1.745540ae.jpg";